module.exports = __webpack_public_path__ + "img/honer9.87dfdeb8.jpg";